import assign from 'lodash/assign';
import constants from '../constants';

const initState = () => ({
  currentArea: {},
});

const area = (state = initState(), action = {}) => {
  const { type, payload } = action;

  if (type === constants.SET_CURRENT_AREA) {
    return assign({}, state, {
      currentArea: payload,
    });
  } else {
    return state;
  }
};

export default area;
